import React from 'react';
import { Link } from 'react-router-dom';
import Avatar from '../../UI/avatar';
import cn from 'classnames';
import { Outlet } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import DeleteAccountModal from './delete-account-modal';
import { useAuth } from '../../../contexts/AuthContext';

type Props = {};

const SettingsPage = (props: Props) => {
  const location = useLocation();
  const { user } = useAuth();
  const isActive = (path: string) => location.pathname === path;
  const [showDeleteAccountModal, setShowDeleteAccountModal] =
    React.useState<boolean>(false);

  return (
    <>
      <div className='gradient-bg-login gradient-bg-decoration'></div>
      <div
        className='overflow-y-auto'
        style={{
          height: 'calc(100vh - var(--header-height))',
          paddingBottom: '20px'
        }}
      >
        <div className='settings'>
          <div className='settings-container'>
            <div className='settings-header'>
              <Avatar size='xxl' />
              <div className='settings-header-info'>
                <h3>{user?.username ?? ''}</h3>
                <p>Manage your account settings and preferences.</p>
              </div>
            </div>
            <div className='settings-content'>
              <div className='settings-nav'>
                <ul className='settings-nav-list'>
                  <li>
                    <Link
                      className={cn({
                        active: isActive('/settings/general')
                      })}
                      to='/settings/general'
                    >
                      General Settings
                    </Link>
                  </li>
                  <li>
                    <Link
                      className={cn({
                        active: isActive('/settings/change-password')
                      })}
                      to='/settings/change-password'
                    >
                      Password
                    </Link>
                  </li>
                  <li>
                    <Link
                      className={cn({
                        active: isActive('/settings/notifications')
                      })}
                      to='/settings/notifications'
                    >
                      Notifications
                    </Link>
                  </li>
                </ul>
                <a
                  href='#'
                  className='link-delete'
                  onClick={() => setShowDeleteAccountModal(true)}
                >
                  Delete Account
                </a>
              </div>
              <div className='settings-main'>
                <Outlet />
              </div>
            </div>
          </div>
        </div>
      </div>
      <DeleteAccountModal
        show={showDeleteAccountModal}
        handleClose={() => setShowDeleteAccountModal(false)}
      />
    </>
  );
};

export default SettingsPage;
